import React from "react";
import classes from "./Tableau.module.css";
import { useEffect } from "react";

const Tableau = (props) => {
  useEffect(() => {
    const divElement = document.getElementById("viz1634796929806");
    let vizElement = divElement.getElementsByTagName("object")[0];
    if (divElement.offsetWidth > 800) {
      vizElement.style.width = "1366px";
      vizElement.style.height = "100%";
    } else if (divElement.offsetWidth > 500) {
      vizElement.style.width = "1366px";
      vizElement.style.height = "100%";
    } else {
      vizElement.style.width = "100%";
      vizElement.style.height = "100%";
    }
    const scriptElement = document.createElement("script");
    scriptElement.src = "https://public.tableau.com/javascripts/api/viz_v1.js";
    vizElement.parentNode.insertBefore(scriptElement, vizElement);
  }, []);

  return (
    <div className={classes.tableau_container}>
      <div
        className="tableauPlaceholder"
        id="viz1634796929806"
        style={{ position: "relative", marginTop: "60px" }}
      >
        <noscript>
          <a href="#">
            <img
              alt="Dashboard 1 "
              src="https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Pa&#47;Patra&#47;Dashboard1&#47;1_rss.png"
              style="border: none"
            />
          </a>
        </noscript>
        <object
          className="tableauViz"
          style={{
            display: "none",
          }}
        >
          <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
          <param name="embed_code_version" value="3" />
          <param name="site_root" value="" />
          <param name="name" value="Patra&#47;Dashboard1" />
          <param name="tabs" value="no" />
          <param name="toolbar" value="yes" />
          <param
            name="static_image"
            value="https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Pa&#47;Patra&#47;Dashboard1&#47;1.png"
          />
          <param name="animate_transition" value="yes" />
          <param name="display_static_image" value="yes" />
          <param name="display_spinner" value="yes" />
          <param name="display_overlay" value="yes" />
          <param name="display_count" value="yes" />
          <param name="language" value="en-US" />
        </object>
      </div>
    </div>
  );
};

export default Tableau;

//http://public.tableau.com/views/Patra/Dashboard1?:embed=y&:showVizHome=no&:host_url=https%3A%2F%2Fpublic.tableau.com%2F&:embed_code_version=3&:tabs=no&:toolbar=yes&:animate_transition=yes&:display_static_image=no&:display_spinner=no&:display_overlay=yes&:display_count=yes&:language=en-US&:loadOrderID=0
